import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

 function ListItemRender(props) {
  
  return (
  <>
    {!!(props.val)?<ListItem sx={{p:0,m:0,pl:2}}><ListItemText sx={{p:0,m:0}} primary={props.val}/></ListItem>:null} 
  </>)
  } 

export default ListItemRender;